function StickyHeaders (els, windowTop, windowHeight, parentClass) {
  // Window
  windowTop = typeof windowTop === 'undefined' ? window.pageYOffset : windowTop
  const windowBottom = typeof windowHeight === 'undefined' ? windowTop + window.innerHeight : windowTop + windowHeight

  // Loop
  Array.prototype.forEach.call(els, function (el) {
    const parent = typeof parentClass === 'undefined' ? el.parentElement : el.closest(parentClass)
    const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    const parentTop = parent.getBoundingClientRect().top + scrollTop
    const parentBottom = parentTop + parent.offsetHeight

    /*
      if (windowBottom > parentBottom) >> add bottom class
      else if (parentBottom > windowBottom && windowBottom > articleTop ) >> add fixed class
      else >> add static class
    */

    // if below the parent >> afix to bottom edge
    if (windowBottom > parentBottom) {
      el.setAttribute('data-sticky-header', 'bottom')
    // if inside the section >> fixed position
    } else if (parentTop <= windowTop && windowBottom <= parentBottom) {
      el.setAttribute('data-sticky-header', 'fixed')
    // otherwise natural scroll position
    } else {
      el.removeAttribute('data-sticky-header')
    }
  })
}

module.exports = StickyHeaders



// WEBPACK FOOTER //
// ./src/assets/js/sticky-headers.js